export default "__VITE_ASSET__qv2bNzp___"